import RIOButtonDropdown, {
    type ButtonDropdownProps as RIOButtonDropdownProps,
} from '@rio-cloud/rio-uikit/ButtonDropdown';

import type { PropsWithTestId } from '../types';

export type ButtonDropdownItem = NonNullable<RIOButtonDropdownProps['items']>[number];

interface ButtonDropdownProps {
    title: string | React.ReactNode;
    items: ButtonDropdownItem[];
    disabled?: boolean;
    className?: string;
}

const ButtonDropdown = ({
    title,
    items,
    disabled,
    className,
    'data-testid': dataTestId,
}: PropsWithTestId<ButtonDropdownProps>) => (
    <RIOButtonDropdown
        {...(dataTestId ? { 'data-testid': dataTestId } : {})}
        title={title}
        items={items}
        bsStyle='muted'
        iconOnly
        dropup
        noCaret
        disabled={disabled}
        className={className}
    />
);

export default ButtonDropdown;
